'use client'

/**
 * Initializes the PostHog analytics SDK for the buyer-facing bidding web app.
 * Rendered once in apps/web/src/app/layout.tsx.
 *
 * Init logic lives in @/lib/posthog — it runs at module-evaluation time when that
 * module is first imported (by this component or PostHogUserIdentify), guaranteeing
 * PostHog is ready before any React effects fire.
 *
 * Required env vars (set in Vercel dashboard):
 *   NEXT_PUBLIC_POSTHOG_KEY   — PostHog project API key
 *   NEXT_PUBLIC_POSTHOG_HOST  — PostHog ingestion host (e.g. "https://us.i.posthog.com")
 */

import { useEffect } from 'react'
import { initPostHog } from '@/lib/posthog'

export default function PostHogInit() {
  useEffect(() => {
    // Fallback call — initPostHog() is idempotent and guards against SSR edge cases
    // where the module-level call in @/lib/posthog was skipped (typeof window === 'undefined').
    initPostHog()
  }, [])

  return null
}
